window.API_CONFIG = {
  BASE_URL: "https://d-phanfhco.gtechdigital.id",
  ENDPOINTS: {
    REGISTER: "/api/register",
    LOGIN: "/api/customer/login",
    CHECKMAIL: "/api/check-email",
    RESET_PASSWORD_INITIATE: "/api/customer/reset-password-initiate",
    CHANGE_PASSWORD: "/api/customer/change-password",
    UPDATE_PROFILE: "/profile",
    NEWSLETTER: "/newsletter-subscription",
    WISHLIST: "/customer-wishlist-data",
    CART_SYNC: "/customer-cart-data",
    ADDRESS_PROVINCES: "/api/locations/provinces",
    ADDRESS_CITIES: "/api/locations/cities",
    ADDRESS_DISTRICTS: "/api/locations/districts",
    ADDRESS_SAVE: "/customer-address-send",
    SAVE_LATER_DATA: "/customer-save-later-data",
  },
};
